type Bucket = 'ABC' | 'Reorder' | 'RTO'

const config: Record<Bucket, { bg: string; text: string; label: string }> = {
  ABC:     { bg: 'bg-blue-50',  text: 'text-blue-700',  label: 'ABC' },
  Reorder: { bg: 'bg-green-50', text: 'text-green-700', label: 'Reorder' },
  RTO:     { bg: 'bg-red-50',   text: 'text-red-700',   label: 'RTO' },
}

export default function BucketBadge({ bucket }: { bucket: Bucket }) {
  const c = config[bucket]
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-md text-xs font-bold tracking-wide ${c.bg} ${c.text}`}>
      {c.label}
    </span>
  )
}
